import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import GameControlBtns from './GameControlBtns';
import ScoreBox from './ScoreBox';

export default class GameHUD extends Phaser.GameObjects.Container {
  constructor(scene) {
    super(scene);
    scene.add.existing(this);

    this.scene = scene;

    this.scoreBox = new ScoreBox(this.scene);
    this.add(this.scoreBox);
    this.gameControls = new GameControlBtns(this.scene);
    this.add(this.gameControls);

    this.gameControls.on('CONTROLS_CLICK', (e) => {this.handleUi(e);});

    this.layoutHUD();
  }

  handleUi(e) {
    this.emit('HUD_INPUT', e);
  };

  showMusicState(on) {
    this.gameControls.showSoundState(on);
  };

  layoutHUD() {
    this.scoreBox.x = 10;
    this.scoreBox.y = 5;
    this.gameControls.x = this.scene.mid.x * 2 - this.gameControls.getBounds().width - 10;
    this.gameControls.y = 10;
  };
}